module.exports = __webpack_public_path__ + "img/tokenpocket.8f090a04.png";